import React from "react";
import { Change } from "./useChangesTracker";
import "./Admin.css";

interface ChangesPreviewModalProps {
  isOpen: boolean;
  changes: Change[];
  onConfirm: () => void;
  onCancel: () => void;
}

const ChangesPreviewModal: React.FC<ChangesPreviewModalProps> = ({
  isOpen,
  changes,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  const getChangeTypeLabel = (type: string) => {
    switch (type) {
      case "add":
        return "+ Adicionar";
      case "edit":
        return "✏️ Editar";
      case "delete":
        return "🗑️ Excluir";
      default:
        return type;
    }
  };

  const getChangeTypeClass = (type: string) => {
    switch (type) {
      case "add":
        return "change-type-add";
      case "edit":
        return "change-type-edit";
      case "delete":
        return "change-type-delete";
      default:
        return "";
    }
  };

  // Group changes by section
  const changesBySection = changes.reduce((acc, change) => {
    if (!acc[change.section]) {
      acc[change.section] = [];
    }
    acc[change.section].push(change);
    return acc;
  }, {} as Record<string, Change[]>);

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div
        className="modal-content changes-preview"
        onClick={(e) => e.stopPropagation()}
      >
        <h2>📋 Pré-visualização das Alterações</h2>

        <div className="changes-preview-warning">
          <p>
            <strong>⚠️ Importante:</strong> Todas as alterações abaixo serão
            salvas no Cloudflare e publicadas no site. Certifique-se de que
            todas as modificações estão corretas antes de continuar.
          </p>
        </div>

        <div className="changes-preview-content">
          {Object.entries(changesBySection).map(([section, sectionChanges]) => (
            <div key={section} className="changes-section">
              <h3>{section}</h3>
              <ul className="changes-list">
                {sectionChanges.map((change) => (
                  <li
                    key={change.id}
                    className={`change-item ${getChangeTypeClass(change.type)}`}
                  >
                    <span className="change-type">
                      {getChangeTypeLabel(change.type)}
                    </span>
                    <span className="change-description">
                      {change.description}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="changes-preview-summary">
          <strong>Total de alterações: {changes.length}</strong>
        </div>

        <div className="form-actions">
          <button onClick={onCancel} className="cancel-button">
            Cancelar
          </button>
          <button onClick={onConfirm} className="save-button">
            Salvar Todas as Alterações
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangesPreviewModal;
